import { Api } from './Api';
import { ApiRequestOptions } from './ApiRequestOptions';
import { atom } from 'recoil';
import { GetEndpointMethodNames } from './GetEndpointMethodNames';
import { GetMethod } from './GetMethod';

export type ApiAtomContent<
  TApi extends Api<any, any>,
  TPath extends TApi['Path'],
  TMethod extends GetEndpointMethodNames<TApi, TPath>,
> = {
  path: TPath;
  method: TMethod;
  error?: TApi['Error'];
  fetching: boolean;
} & (
  | {
      isLoaded: true;
      data: GetMethod<TApi, TPath, TMethod>['Response'];
      request: ApiRequestOptions<TApi, TPath, TMethod>;
    }
  | {
      isLoaded: false;
      data: undefined;
      request: undefined;
    }
);

/**
 * Returns new atom
 *
 * @param {TPath} path - API endpoint path
 * @param {TMethod} method - fetch method
 * @param {string} [key=`${path}|${method.toString()}`] - optional key string for unique atom identification
 * @returns new atom with default values
 */
export const createApiAtom = <
  TApi extends Api<any>,
  TPath extends TApi['Path'],
  TMethod extends GetEndpointMethodNames<TApi, TPath>,
>(
  path: TPath,
  method: TMethod,
  key: string,
) => {
  return atom<ApiAtomContent<TApi, TPath, TMethod>>({
    key,
    default: {
      path,
      method,
      fetching: false,
      isLoaded: false,
      data: undefined,
      request: undefined,
    },
  });
};
